// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-act-tip[data-v-696f97eb] {\n  width: 36px;\n  height: 36px;\n  z-index: 100;\n  position: fixed;\n  bottom: 58.7px;\n  right: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
